// @flow
import logger from 'Logger';
import { sendErrorToSentry } from 'Errors/clientErrorHandler';
/**
 * Flow has a special understanding of invariant
 * invariant(condition, '');
 * is understood like
 * if (!condition) throw New Error('');
 *
 * Which let's us mute some flow errors that we know can't happen, without throwing an error
 */
export const invariant = (condition: mixed, error: string) => {
  if (!condition) {
    logger.error(error);
    sendErrorToSentry({ error: new Error(error) });
  }
};
